<template>
	<div v-if="assignment.DETAILS !== undefined" class="class-page">
			<!-- Header -->
			<ClassPageHeader :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true" course-content="courseContent"/>


			<div class="assignment-bin">
					<div class="display-table feedback-page">
							<div class="display-container" v-if="!!assignment.FEEDBACK.GRADED_BY">

									<!-- Assignment header -->
									<div class="header color-status">
											<div class="float-left">
												<h2>{{ $t( 'MAIN_CONTENT.Feedback.feedback' ) }}</h2>
											</div>
											<div class="score-pill float-right">
												{{ $t( 'MAIN_CONTENT.commonContent.score' ) }} 
												<strong>
													{{ $t( 'MAIN_CONTENT.AssignmentBin.gradeOverPoints', { grade: assignment.DETAILS.GRADE_CODE, points: assignment.DETAILS.MAX_POINTS } ) }}
												</strong>
											</div>
									</div>

									<!-- Assignment sub-header -->
									<div class="sub-header" v-html="assignment.FEEDBACK.FEEDBACK_TEXT"></div>

									<!-- Attachments -->
									<div class="attached">
										<div class="header-attached">
											<h3>
												{{ $t( 'MAIN_CONTENT.AssignmentBin.attachedFiles' ) }} 
												<span class="pill pill-attached">
													{{ assignment.FEEDBACK.ATTACHMENTS.length }}
												</span>
											</h3>
										</div>
										<div v-for="attached in assignment.FEEDBACK.ATTACHMENTS" :key="attached.REPORT_ID" class="attached-file">
											<a :href="attached.ATTACHMENT_URL" target="_blank">
												<i :class="`fas ${ fileType( attached.CONTENT_ID ) }`" aria-hidden="true"></i> {{ attached.CONTENT_FILENAME }}
											</a>
										</div>
									</div>
							</div>
							<div class="display-container" v-else>
								{{ $t( 'MAIN_CONTENT.Feedback.noFeedbackMessage' ) }}
							</div>

							<!-- Button -->
							<div class="back-link">
								<a @click="$router.go(-1)">
									<i class="fas fa-caret-left" aria-hidden="true"></i> 
									{{ $t( 'MAIN_CONTENT.commonContent.goBack' ) }}
								</a>
							</div>
					</div>
			</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ClassPageHeader from "../Header.vue";
import ClassPageFooter from "../Footer.vue";

import ClassPageHomeResource from '../../../api/ClassPageHome';
import ClassPageDetailsResource from '../../../api/ClassPageDetails';
import ClassPageAssignmentBinResource from '../../../api/ClassPageAssignmentBin';
import ClassPageAssignmentBinAssignmentResource from '../../../api/ClassPageAssignmentBinAssignment';
import ClassPageMenuResource from '../../../api/ClassPageMenu';
import CoursesResource from '../../../api/Courses';

export default {
    name: "FeedBack",

    data: () => ({
			menu: [],
			details: {},
			course: {},
      assignment: {},
			courseContent: {},
    }),

    components: { ClassPageHeader },

    computed: {
			...mapGetters( [ "selectedStudent" ] ),
      assignmentId: function () {
				return this.$route.params.assignmentId ? this.$route.params.assignmentId : 0;
			},
			sectionId() {
				return this.$route.params.folderId ? this.$route.params.folderId : 0;
			},
			assignmentBinType(){
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBinFeedback' ){
					type = 'course';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBinFeedback' ){
					type = 'course';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBinFeedback' ) {
					type = 'group';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBinFeedback' ) {
					type = 'student';
				}

				return type;
			},
			assignmentBinRouteName(){
				let type = '';
				if( this.$route.name === 'ClassPageAssignmentBinFeedback' ){
					type = 'ClassPageAssignmentBin';
				} else if( this.$route.name === 'ClassPageSectionAssignmentBinSubmissionFeedback' ){
					type = 'ClassPageSectionAssignmentBin';
				} else if ( this.$route.name === 'ClassPageGroupAssignmentBinFeedback' ) {
					type = 'ClassPageGroupAssignmentBin';
				} else if ( this.$route.name === 'ClassPageStudentAssignmentBinFeedback' ) {
					type = 'ClassPageStudentAssignmentBin';
				}

				return type;
			},
    },

    methods: {
			fetchAssignmentBinAssignment(){
				const Assignment = new ClassPageAssignmentBinAssignmentResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						assignmentBinId: this.$route.params.assignmentBinId,
						assignmentId: this.$route.params.assignmentId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.assignmentBinType,
				});

				Assignment.get().then(() => {
					this.assignment = Assignment.getResponseData();
				});
			},
			fetchMenu(){
				const ClassPageMenu = new ClassPageMenuResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageMenu.get().then(()=>{
					this.menu = ClassPageMenu.getResponseData();
				});
			},
			fetchDetails(){
				const ClassPageDetails = new ClassPageDetailsResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageDetails.get().then(()=>{
					this.details = ClassPageDetails.getResponseData();
				});
			},
			fetchCourse(){
				var Course = new CoursesResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				Course.get().then(()=>{
					this.course = Course.getResponseData();
				});
			},
			fetchClassHome(){
				const ClassPageHome = new ClassPageHomeResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
				});

				ClassPageHome.get().then(()=>{
					this.courseContent = ClassPageHome.getResponseData().COURSE_CONTENT;
				});
			},
        /**
         * Determines the icon to use per file
         * @param { String } mime
         * @returns { String }
         */
        fileType: function ( mime ) {
            if ( mime.includes( "word" ) )
                return "fa-file-word word-file";

            else if ( mime.includes( "powerpoint" ) )
                return "fa-file-powerpoint ppt-file";

            else if ( mime.includes( "pdf" ) )
                return "fa-file-pdf pdf-file";
            
            return "fa-file default-file";
        }
    },

    created () {
				this.fetchMenu();
				this.fetchDetails();
				this.fetchCourse();
				this.fetchClassHome();
				this.fetchAssignmentBinAssignment();
    }
};
</script>
